module.exports = __webpack_public_path__ + "static/duke-b27a1b7ca17ca34f42516b3836a0e26b.jpg";